import React from "react";
import { PlusOutlined, FileExcelOutlined } from "@ant-design/icons";
import {
  Drawer,
  Button,
  PageHeader,
} from "antd";
import { useState } from "react";



import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import ProgrammComercialEntry from "../../components/masters/programm-commercial/ProgrammComercialEntry";
import ProgrammCommercialList from "../../components/masters/programm-commercial/ProgrammCommercialList";
import { DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";
import { ALL_COMMERCIAL_HEAD_XLS_URL } from "../../utility/URL";
import commonUtility from "../../utility/Utils";
// import ProgrammComercialEntry from "../components/programm-commercial/ProgrammComercialEntry";
// import ProgrammCommercialList from "../components/programm-commercial/ProgrammCommercialList";




const ProgramCommercial = () => {
  const [visible, setVisible] = useState(false);
  const [programmcommercialAddData, setProgrammcommercialAddData] = useState({
    component_id: 0,
    description: '',
    programme_id: '',
    group_id: '',
    programme_name: '',
    account_name: '',
    account_id: '',
    amount: "",
    is_gst_applicable: 'N',
    is_reg_component: '',
    component_type: '',
    cgst_id: '',
    sgst_id: '',
    mode: "ADD",
    is_security: "N",
    is_active: "Y",
    for_month: '',
    rate_for: 'MEMBER'
  });

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Commercial Heads"
          subTitle=""
          extra={[
            <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer}>
              <PlusOutlined /> Add
            </Button>,

            <Button key="2" className="custom-button-white" shape="round" size="medium" onClick={() => commonUtility.openInNewTab(ALL_COMMERCIAL_HEAD_XLS_URL)}>
              <FileExcelOutlined /> Excel
            </Button>,
          ]}
        ></PageHeader>

        <Drawer
          title="Add new programm commercial"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose={true}
          closeIcon={<><DrawableCloseIcon /></>}
        >
          <ProgrammComercialEntry data={programmcommercialAddData} onDrawerClose={onClose} />
        </Drawer>

        <div className="tableView">
          <div className="form-content">
            <ProgrammCommercialList />
          </div>
        </div>

      </div>
    </div>
  );
};

export default ProgramCommercial;
